module.exports = __webpack_public_path__ + "static/media/rectangle-landscape.47f56065.svg";